import React, { useState, useRef } from 'react';
import styles from './coursesScreen.module.css';
import CourseCard from '../../components/courseCard/CourseCard';
import SyllabusModal from '../../components/syllabusModal/SyllabusModal';
import FormModal from '../../components/formModal/FormModal';
import useScrollReveal from '../../hooks/useScrollReveal';

import romi3 from '../../images/romi_3.webp';
import romi4 from '../../images/romi_4.webp';
import romi5 from '../../images/romi_5.webp';
import romi7 from '../../images/romi_7.webp';
import maximovaPro from '../../assets/ערכת מקסימובה.webp';
import maximovaLogo from '../../images/maximova-logo.webp';
import certImg from '../../images/תעודה בינלאומית (1).webp';

const courses = [
  {
    id: 'eyebrows',
    title: 'עיצוב ושיקום גבות ושעוות פנים',
    subtitle: 'קורס פרטני אחת על אחת ע״י המאסטרית רומי פרץ',
    duration: 'יום אחד / יומיים',
    location: 'מושב חבר',
    type: 'קורס אישי',
    bgImage: romi5,
    highlights: [
      { icon: 'cert', label: 'תעודת הסמכה' },
      { icon: 'kit', label: 'ערכה מלאה' },
      { icon: 'support', label: 'ליווי צמוד' },
    ],
    includes: [
      'תעודת הסמכה ע״י רומי פרץ',
      'חוברת חומר עיוני מפורטת כולל שלבי העבודה (כוללת הסברים על הכל, כולל תמונות ודוגמאות)',
      'ליווי צמוד לאחר הקורס',
      'שיווק נכון בפלטפורמות ובידול',
      'ארגז כלים למיינדסט של מנצחת',
      'טכניקות צילום כולל עדשת מאקרו ואפליקציות עריכה',
      'ערכה מלאה ומפוארת לתחילת עבודה יום למחרת עם כל המוצרים הכי איכותיים שאני עובדת איתם (מכונת שעווה, שעווה, פינצטות, חוט, צבעים לגבות ועוד)',
      'קוד קופון בלעדי לתלמידות שלי המעניק הנחה של 5% באתר גל קוסמטיקס ו-10% הנחה על כל קטגוריית MAXYMOVA',
    ],
    theory: [
      'חשיבות הסטרליזציה',
      'מורפולוגיה',
      'סוגי גבות וחשיבותן למבנה הפנים',
      'שיקום גבות (גילאים לשיקום גבות)',
      'טכניקה מקצועית בכל השיטות - חוט, פינצטה, שעווה',
      'אבחון סוגי השיער וחשיבות סוג השיער',
      'מריטה נכונה',
      'שרטוט',
      'גזירה ועבודה נכונה',
      'קולוריסטה - תורת הצבעים, צביעה בשיטה המיוחדת שלי',
      'שעוות פנים',
      'איך לצלם גבות בצורה הבולטת ביותר',
    ],
    practice: [
      'תרגול שלך לראשונה על בובת הדגמה',
      'עבודה עצמאית על 2 מודליסטיות',
    ],
    structureTags: ['יום אחד עיוני + מעשי', 'אופציה ליומיים', 'מודליסטית ראשונה ביום 1', 'עבודה עצמאית בפיקוח ביום 2'],
  },
  {
    id: 'lashes-brows',
    title: 'הרמת ריסים + הרמת גבות',
    subtitle: 'קורס משולב פרטני אחת על אחת ע״י המאסטרית רומי פרץ',
    duration: 'יומיים (אופציה ליום אחד)',
    location: 'מושב חבר',
    type: 'קורס אישי',
    bgImage: romi3,
    highlights: [
      { icon: 'cert', label: '2 תעודות הסמכה' },
      { icon: 'kit', label: 'ערכה מלאה' },
      { icon: 'support', label: 'ליווי צמוד' },
    ],
    includes: [
      '2 תעודות הסמכה - ע״י רומי פרץ + תעודה בינלאומית של חברת הפרימיום מקסימובה העולמית',
      'חוברת חומר עיוני מפורטת כולל שלבי העבודה (כוללת הסברים על הכל, כולל תמונות ודוגמאות)',
      'ליווי צמוד לאחר הקורס',
      'שיווק נכון בפלטפורמות ובידול',
      'ארגז כלים למיינדסט של מנצחת',
      'טכניקות צילום כולל עדשת מאקרו ואפליקציות עריכה',
      'ערכה מלאה ומפוארת לתחילת עבודה יום למחרת עם כל המוצרים הכי איכותיים שאני עובדת איתם',
      'קוד קופון בלעדי לתלמידות שלי המעניק הנחה של 5% באתר גל קוסמטיקס ו-10% הנחה על כל קטגוריית MAXYMOVA',
    ],
    theory: [
      'מבנה העין והריסים',
      'מבנה השערה',
      'מחזור חיי השיערה',
      'PH של חומרים ואיך לדעת עם איזה חומר נכון לנו לעבוד',
      'מחלות עיניים וסכנות',
      'הכרת הכלים והחומרים',
      'שלבי הטיפול',
      'הסבר על כל סוגי הסיליקונים לריסים',
      'איך להתאים מידה נכונה',
      'איך להוציא הרמה בטכניקה המקסימלית והמתקדמת ביותר',
      'הצהרות בריאות ללקוחה',
      'תיקון הרמה כושלת',
      'חיטוי ועיקור הכלים',
    ],
    practice: [
      'טיפול ראשון שלי על מודליסטית 1 - את צופה',
      'תרגול שלך על 2 מודליסטיות הרמת ריסים וגבות בהכוונה ופיקוח מלא שלי לאורך כל התהליך עד שתקבלי ביטחון מלא',
    ],
    structureTags: ['יומיים עיוני + מעשי', 'אופציה ליום אחד', 'יום 1: עיוני + צפייה', 'יום 2: 3 מודליסטיות בפיקוח', 'כיבוד במהלך הקורס'],
  },
  {
    id: 'lashes-workshop',
    title: 'השתלמות הרמת ריסים',
    subtitle: 'השתלמות פרטני אחת על אחת ע״י המאסטרית רומי פרץ',
    duration: 'יום אחד',
    location: 'מושב חבר',
    type: 'השתלמות אישית',
    bgImage: romi7,
    highlights: [
      { icon: 'cert', label: '2 תעודות הסמכה' },
      { icon: 'kit', label: 'ערכת MAXYMOVA' },
      { icon: 'photo', label: 'טכניקות צילום' },
    ],
    includes: [
      '2 תעודות הסמכה ע״י רומי פרץ + מקסימובה העולמית',
      'חוברת חומר עיוני מפורטת כולל שלבי העבודה (כוללת הסברים על הכל, כולל תמונות ודוגמאות)',
      'ליווי צמוד לאחר ההשתלמות',
      'שיווק נכון בפלטפורמות ובידול',
      'קוד קופון בלעדי לתלמידות שלי המעניק הנחה של 5% באתר גל קוסמטיקס ו-10% הנחה על כל קטגוריית MAXYMOVA',
      'טכניקות צילום כולל עדשת מאקרו ואפליקציות עריכה',
      'ערכת חומרים של חברת הפרימיום MAXYMOVA האיטלקית במתנה (בוטוקס, סרום קוקטייל, חומר 1.2, סרום אפטר ליפט, ואת השתלים האהובים עליי)',
    ],
    theory: [
      'מבנה העין והריסים',
      'מבנה השערה',
      'מחזור חיי השיערה',
      'PH של חומרים ואיך לדעת עם איזה חומר נכון לנו לעבוד',
      'מחלות עיניים וסכנות',
      'הכרת הכלים והחומרים',
      'שלבי הטיפול',
      'הסבר על כל סוגי הסיליקונים לריסים',
      'איך להתאים מידה נכונה',
      'איך להוציא הרמה בטכניקה המקסימלית והמתקדמת ביותר',
      'הצהרות בריאות ללקוחה',
      'תיקון הרמה כושלת',
      'חיטוי ועיקור הכלים',
    ],
    practice: [
      '2 מודליסטיות - מודליסטית אחת משותפת שלי ושלך ומודליסטית שלך לבד בפיקוח מלא שלי',
    ],
    structureTags: ['יום אחד אינטנסיבי', 'כיבוד במהלך הקורס'],
  },
  {
    id: 'triple',
    title: 'קורס טריפל עיצוב גבות + הרמת ריסים וגבות',
    subtitle: 'קורס פרטני אחת על אחת ע״י המאסטרית רומי פרץ',
    duration: '3 ימים (אופציה ליומיים)',
    location: 'מושב חבר',
    type: 'קורס אישי',
    bgImage: romi4,
    highlights: [
      { icon: 'cert', label: '3 תעודות הסמכה' },
      { icon: 'kit', label: 'ערכה מלאה' },
      { icon: 'support', label: 'ליווי צמוד' },
    ],
    includes: [
      '3 תעודות הסמכה ע״י רומי פרץ + תעודה בינלאומית של חברת הפרימיום מקסימובה העולמית',
      'חוברת חומר עיוני מפורטת כולל שלבי העבודה (כוללת הסברים על הכל, כולל תמונות ודוגמאות)',
      'ליווי צמוד לאחר הקורס',
      'שיווק נכון בפלטפורמות ובידול',
      'ארגז כלים למיינדסט של מנצחת',
      'טכניקות צילום כולל עדשת מאקרו ואפליקציות עריכה',
      'ערכה להרמת ריסים וגבות + עיצוב גבות מלאה ומפוארת לתחילת עבודה יום למחרת עם כל המוצרים הכי איכותיים שאני עובדת איתם',
      'קוד קופון בלעדי לתלמידות שלי המעניק הנחה של 5% באתר גל קוסמטיקס ו-10% הנחה על כל קטגוריית MAXYMOVA',
    ],
    theory: [
      'עיצוב גבות - חשיבות הסטרליזציה',
      'עיצוב גבות - מורפולוגיה',
      'עיצוב גבות - סוגי גבות וחשיבותן למבנה הפנים',
      'עיצוב גבות - שיקום גבות (גילאים לשיקום גבות)',
      'עיצוב גבות - טכניקה מקצועית בכל השיטות - חוט, פינצטה, שעווה',
      'עיצוב גבות - אבחון סוגי השיער וחשיבות סוג השיער',
      'עיצוב גבות - מריטה נכונה',
      'עיצוב גבות - שרטוט',
      'עיצוב גבות - גזירה ועבודה נכונה',
      'עיצוב גבות - קולוריסטה - תורת הצבעים',
      'עיצוב גבות - שעוות פנים',
      'עיצוב גבות - איך לצלם גבות בצורה הבולטת ביותר',
      'הרמת ריסים+גבות - מבנה העין והריסים',
      'הרמת ריסים+גבות - מבנה השערה',
      'הרמת ריסים+גבות - מחזור חיי השיערה',
      'הרמת ריסים+גבות - PH של חומרים ואיך לדעת עם איזה חומר נכון לנו לעבוד',
      'הרמת ריסים+גבות - מחלות עיניים וסכנות',
      'הרמת ריסים+גבות - הכרת הכלים והחומרים',
      'הרמת ריסים+גבות - שלבי הטיפול',
      'הרמת ריסים+גבות - הסבר על כל סוגי הסיליקונים לריסים',
      'הרמת ריסים+גבות - איך להתאים מידה נכונה',
      'הרמת ריסים+גבות - איך להוציא הרמה בטכניקה המקסימלית והמתקדמת ביותר',
      'הרמת ריסים+גבות - תיקוני הרמה',
      'הרמת ריסים+גבות - הצהרות בריאות ללקוחה',
      'הרמת ריסים+גבות - חיטוי ועיקור הכלים',
    ],
    practice: [
      'טיפול ראשון שלי על מודליסטית 1 - את צופה',
      'תרגול שלך עיצוב גבות על בובת תרגול',
      'תרגול שלך על 4 מודליסטיות הרמת ריסים + עיצוב גבות בהכוונה ופיקוח מלא שלי לאורך כל התהליך עד שתקבלי ביטחון מלא',
    ],
    structureTags: ['3 ימים עיוני + מעשי', 'אופציה ליומיים', 'יום 1: עיוני + צפייה', 'יום 2+3: 4 מודליסטיות בפיקוח', 'כיבוד במהלך הקורס'],
  },
];

const perks = [
  { img: maximovaPro, title: 'ערכת פרימיום מלאה',     desc: 'תקבלי ערכה עם כל החומרים של {logo} - ככה שאת יכולה להתחיל לעבוד כבר למחרת בלי לקנות כלום', hasLogo: true },
  { img: certImg,     title: 'תעודה בינלאומית',         desc: 'cert-logo', rotateImg: true, hasCertLogo: true, imgPos: 'center 0%' },
  { img: romi3,       title: 'ליווי גם אחרי הקורס',   desc: 'אני לא נעלמת אחרי הקורס - אני זמינה לך לכל שאלה, התייעצות או חשש גם חודשים אחרי שסיימנו' },
  { img: romi4,       title: 'בניית יסודות שיווקיים',        desc: 'אני מלמדת אותך איך לבנות נוכחות ברשתות, לשווק את עצמך נכון ולהבדיל את עצמך מכל השאר בשוק' },
  { img: romi5,       title: 'מיינדסט של מנצחת',        desc: 'אני מכינה אותך גם מבחינה מנטלית - איך להתמודד עם התחלה חדשה, לא לפחד מלקוחות ראשונות תמחור נכון וביטחון כבר מהרגע הראשון', fullWidth: true },
];

function CoursesScreen() {
  const [isSyllabusOpen, setIsSyllabusOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  const handleSyllabusClick = (course) => {
    setSelectedCourse(course);
    setIsSyllabusOpen(true);
  };

  const handleFormOpen = () => {
    setIsSyllabusOpen(false);
    setIsFormOpen(true);
  };

  return (
    <>
      <section className={styles.courses} id="courses" ref={sectionRef}>
        {/* ── Ambient glows ── */}
        <div className={styles.glowTopRight} />
        <div className={styles.glowBottomLeft} />
        <div className={styles.glowCenter} />

        {/* ── Sparkles ── */}
        {[...Array(8)].map((_, i) => (
          <div key={i} className={`${styles.sparkle} ${styles[`sp${i + 1}`]}`} />
        ))}

        <div className={styles.container}>
          {/* ── Intro lead-in ── */}
            <div className={styles.intro} data-sr="0">
              <h2 className={styles.beliefTitle}>
                וכולן עברו את אחת מהדרכים הבאות
              </h2>
              <p className={styles.beliefBody}>
                ריכזתי עבורך את כל הידע שצברתי במהלך השנים ל-4 קורסים הכי פרקטיים שיכולים להיות
              </p>
              <p className={styles.beliefBody}>
                לחצי על כל קורס כדי לראות את הסילבוס המלא
              </p>
            </div>

          <div className={styles.coursesGrid}>
            {courses.map((course, i) => (
              <CourseCard
                key={course.id}
                course={course}
                index={i}
                onSyllabusClick={handleSyllabusClick}
              />
            ))}
          </div>

          {/* ── Perks  -  what you get in every course ── */}
            <div className={styles.perksIntro} data-sr="0">
              <h3 className={styles.perksTitle}>
                ובכל אחד מהם תקבלי <em className={styles.perksEm}>הרבה יותר</em> מרק קורס
              </h3>
              <p className={styles.perksBody}>
                כי אצלי יוצאות עם מקצוע ביד ומוכנות לעבודה מיד אחרי הקורס ולא רק עם התעודה
              </p>
              <h4 className={styles.perksSubtitle}>
                <em className={styles.perksEm}>כל</em> הקורסים מכילים:
              </h4>
            </div>

          <div className={styles.perksGrid}>
            {perks.map((p, i) => (
              <div key={i} data-sr={String(0.05 + i * 0.08)} className={p.fullWidth ? styles.perkFull : ''}>
                <div className={styles.perkCard}>
                  <div className={styles.perkImgPanel}>
                    <img src={p.img} alt="" className={`${styles.perkImg} ${p.rotateImg ? styles.certImg : ''}`} loading="lazy" style={p.imgPos ? { objectPosition: p.imgPos } : undefined} />
                    <div className={styles.perkImgOverlay} />
                  </div>
                  <div className={styles.perkContent}>
                    <div className={styles.perkTitle}>{p.title}</div>
                    <div className={styles.perkDesc}>
                      {p.hasLogo ? (
                        <>תקבלי ערכה עם כל החומרים של <img src={maximovaLogo} alt="Maximova" className={styles.inlineLogo} loading="lazy" /> - ככה שאת יכולה להתחיל לעבוד כבר למחרת בלי לקנות כלום</>
                      ) : p.hasCertLogo ? (
                        <>תעודה מוכרת בינלאומית מטעם <img src={maximovaLogo} alt="Maximova" className={styles.inlineLogo} loading="lazy" /></>
                      ) : p.desc}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SyllabusModal
        isOpen={isSyllabusOpen}
        course={selectedCourse}
        onClose={() => {
          setIsSyllabusOpen(false);
          setSelectedCourse(null);
        }}
        onFormOpen={handleFormOpen}
      />

      <FormModal
        isOpen={isFormOpen}
        onClose={() => {
          setIsFormOpen(false);
          setSelectedCourse(null);
        }}
        selectedCourse={selectedCourse?.title}
      />
    </>
  );
}

export default CoursesScreen;
